"use strict";

Object.defineProperty(exports, "__esModule", {
  value: true
});
exports.getUserCookiePreferencesFromCookieValue = getUserCookiePreferencesFromCookieValue;
exports.default = exports.defaultCookiePreferences = void 0;

var _browserCookies = _interopRequireDefault(require("browser-cookies"));

function _interopRequireDefault(obj) { return obj && obj.__esModule ? obj : { default: obj }; }

function ownKeys(object, enumerableOnly) { var keys = Object.keys(object); if (Object.getOwnPropertySymbols) { var symbols = Object.getOwnPropertySymbols(object); if (enumerableOnly) symbols = symbols.filter(function (sym) { return Object.getOwnPropertyDescriptor(object, sym).enumerable; }); keys.push.apply(keys, symbols); } return keys; }

function _objectSpread(target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i] != null ? arguments[i] : {}; if (i % 2) { ownKeys(source, true).forEach(function (key) { _defineProperty(target, key, source[key]); }); } else if (Object.getOwnPropertyDescriptors) { Object.defineProperties(target, Object.getOwnPropertyDescriptors(source)); } else { ownKeys(source).forEach(function (key) { Object.defineProperty(target, key, Object.getOwnPropertyDescriptor(source, key)); }); } } return target; }

function _defineProperty(obj, key, value) { if (key in obj) { Object.defineProperty(obj, key, { value: value, enumerable: true, configurable: true, writable: true }); } else { obj[key] = value; } return obj; }

function _slicedToArray(arr, i) { return _arrayWithHoles(arr) || _iterableToArrayLimit(arr, i) || _nonIterableRest(); }

function _nonIterableRest() { throw new TypeError("Invalid attempt to destructure non-iterable instance"); }

function _iterableToArrayLimit(arr, i) { var _arr = []; var _n = true; var _d = false; var _e = undefined; try { for (var _i = arr[Symbol.iterator](), _s; !(_n = (_s = _i.next()).done); _n = true) { _arr.push(_s.value); if (i && _arr.length === i) break; } } catch (err) { _d = true; _e = err; } finally { try { if (!_n && _i["return"] != null) _i["return"](); } finally { if (_d) throw _e; } } return _arr; }

function _arrayWithHoles(arr) { if (Array.isArray(arr)) return arr; }

var ADVERTISING_COOKIE_KEY = '4';
var FUNCTIONAL_COOKIE_KEY = '3';
var COOKIE_NAME = 'OptanonConsent';
/**
 * To be returned in case of any trouble parsing the OptanonConsent Cookie
 */

var defaultCookiePreferences = {
  isFunctionalCookieBlocked: false,
  isAdvertisingCookieBlocked: false
};
/**
 * Function to parse OptanonConsent cookie and return the groups as a dictionary
 */

exports.defaultCookiePreferences = defaultCookiePreferences;

function parseOptanonCookie(optanonCookie) {
  var optanonConsent = {};

  if (optanonCookie !== null) {
    var groupStringArray = optanonCookie.split('&').filter(function (element) {
      return element.includes('groups=');
    });

    if (groupStringArray.length > 0) {
      var groupSplit = groupStringArray[0].substring(groupStringArray[0].indexOf('='));
      groupSplit.split(',').forEach(function (element) {
        if (element.split(':').length > 1) {
          var _element$split = element.split(':'),
              _element$split2 = _slicedToArray(_element$split, 2),
              key = _element$split2[0],
              val = _element$split2[1];

          optanonConsent[key] = val;
        }
      });
    }
  }

  return optanonConsent;
}
/**
 * Method to read cookie preferences and return them.
 * @param {parsed optanonConsent object} optanonConsent
 * @returns {cookie preferences} cookiePreferences
 */


function readUserCookiePreference(optanonConsent) {
  var cookiePreferences = _objectSpread({}, defaultCookiePreferences);

  if (Object.keys(optanonConsent).length !== 0) {
    if (optanonConsent[FUNCTIONAL_COOKIE_KEY] !== undefined) {
      cookiePreferences.isFunctionalCookieBlocked = optanonConsent[FUNCTIONAL_COOKIE_KEY] === '0';
    }

    if (optanonConsent[ADVERTISING_COOKIE_KEY] !== undefined) {
      cookiePreferences.isAdvertisingCookieBlocked = optanonConsent[ADVERTISING_COOKIE_KEY] === '0';
    }
  }

  return cookiePreferences;
}
/**
 * (Use client side)
 * Function to fetch document.cookie and extract user consent from the OptanonConsent cookie
 * @returns object containing functional and advertising preferences.
 */


function getUserCookiePreferences() {
  var optanonConsentCookie = _browserCookies.default.get(COOKIE_NAME);

  var optanonConsent = parseOptanonCookie(optanonConsentCookie);
  return readUserCookiePreference(optanonConsent);
}
/**
 * Function to fetch Cookie preferences when cookie value is provided, use in SSR
 * @param {optanonConsentValue} value of OptanonConsent cookie
 * @returns {cookie preferences} cookiePreferences
 */


function getUserCookiePreferencesFromCookieValue(optanonConsentValue) {
  var decodedValue = decodeURIComponent(optanonConsentValue);
  var optanonConsent = parseOptanonCookie(decodedValue);
  return readUserCookiePreference(optanonConsent);
}

var _default = getUserCookiePreferences;
exports.default = _default;